// extracted by mini-css-extract-plugin
module.exports = {"container":"InputFile_container__1aiNd","input":"InputFile_input__W3voh","label":"InputFile_label__IBcSI","fadeIn":"InputFile_fadeIn__csmSx","fadeIn2":"InputFile_fadeIn2___0Er4"};